import { FC } from 'react';
import { faPhone } from '@fortawesome/pro-regular-svg-icons';

import RcsSectionBlock from './RcsSectionBlock';
import InfoItem from './InfoItem';
import InfoItemLayout from './InfoItemLayout';
import { CampaignDetail } from '@/apis/core/types';

interface TechnicalContactSectionProps {
  campaign?: CampaignDetail;
}

const TechnicalContactSection: FC<TechnicalContactSectionProps> = ({
  campaign,
}) => {
  return (
    <RcsSectionBlock
      icon={faPhone}
      title="Technical Contact"
      showDivider={true}
      data-testid="campaignTechnicalContact"
    >
      <InfoItemLayout.Vertical>
        <InfoItemLayout.Horizontal>
          <InfoItem title="Name">{campaign?.technicalContactName}</InfoItem>
          <InfoItem title="Job Title">
            {campaign?.technicalContactJobTitle}
          </InfoItem>
        </InfoItemLayout.Horizontal>
        <InfoItemLayout.Horizontal>
          <InfoItem title="Email">{campaign?.technicalContactEmail}</InfoItem>
        </InfoItemLayout.Horizontal>
      </InfoItemLayout.Vertical>
    </RcsSectionBlock>
  );
};

export default TechnicalContactSection;
